<template>
  <v-app style="background-color: lightgray;">
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar dense>
        <v-toolbar-title>Authorize List</v-toolbar-title>
        <v-spacer></v-spacer>
        <div>
          <v-btn color="error" @click="backToLogin()">Logout</v-btn>
        </div>
      </v-toolbar>
    </v-card>

    <v-container style="padding:0px;">
      <div v-if="errAuthList == ''">
        <div class="col-xs-12" style="margin-bottom: 30px;">
          <v-card
            v-for="list in authList"
            :key="list.ID"
            class="list-group-item clearfix border"
            style="margin:10px;"
            @click="
              authListInfo(list.trnauthid, list.trnhdrid, list.trnauthType)
            "
          >
            <div class="col-xs-12 pull-left" style="padding: 0px;">
              <h2
                v-if="list.trnauthType == 1"
                class="list-group-item-text"
                style="color:#0099ff"
              >
                Purchase Requisition
              </h2>
              <h2
                v-if="list.trnauthType == 2"
                class="list-group-item-text"
                style="color:#0099ff"
              >
                Purchase Order
              </h2>
              <h5 class="list-group-item-text listTxt">
                Doc No: {{ list.trnhdrDocNo }}
              </h5>
              <h5 class="list-group-item-text listTxt">
                Doc Date:
                {{ list.trnhdrDocDate | currentDate(list.trnhdrDocDate) }}
              </h5>
              <h5 class="list-group-item-text listTxt">
                Total Qty:
                {{ list.trnhdrTotalQty | currency(list.trnhdrDocDate) }}
              </h5>
              <h5
                v-if="list.cmpName != null"
                class="list-group-item-text listTxt"
              >
                Company Total Amt:
                {{ list.trnhdrTotalAmt1 | currency(list.trnhdrTotalAmt1) }}
              </h5>
              <h5 class="list-group-item-text listTxt">
                Vendor Total Amt:
                {{ list.trnhdrTotalAmt2 | currency(list.trnhdrTotalAmt2) }}
              </h5>
              <h5 class="list-group-item-text listTxt">
                Request Name:
                {{ list.trnhdrCreateName }}
              </h5>
              <h5 class="list-group-item-text listTxt">
                Disc Percent:
                {{ list.trnhdrDiscPercent | currency(list.trnhdrDiscPercent) }}
              </h5>
              <h5
                v-if="list.cmpName != null"
                class="list-group-item-text listTxt"
              >
                company Name:
                {{ list.cmpName }}
              </h5>
              <h5
                v-if="list.trnauthType == 1"
                class="list-group-item-text listTxt"
              >
                Expired Date:
                {{ list.trnhdrPRExpDate | currentDate(list.trnhdrPRExpDate) }}
              </h5>
              <h5
                v-if="list.trnauthType == 2"
                class="list-group-item-text listTxt"
              >
                Expired Date:
                {{ list.trnhdrPOExpDate | currentDate(list.trnhdrPOExpDate) }}
              </h5>
            </div>
          </v-card>
        </div>
      </div>

      <div v-if="errAuthList != ''">
        <div v-if="errAuthList == 0">
          <h2 style="margin:30px">No list found to authorize</h2>
        </div>
        <div v-if="errAuthList != 0">
          <h2 style="margin:30px">{{ errAuthList }}</h2>
        </div>
      </div>
    </v-container>

    <v-layout class="text-xs-center">
      <v-dialog v-model="logoutDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
            >Inform</v-card-title
          >
          <v-card-text style="padding:0px;">
            <h3 style="font-size:18px;padding:10px 10px 0px 10px;">
              Are you sure to Logout?
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" text @click="sureLogOut()">Yes</v-btn>
            <v-btn color="primary" text @click="logoutDialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script>
import JS from '../services/JsonService'
export default {
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt.toFixed(2)
    },
    currentDate(date) {
      //console.log(date)
      const date1 = date.substring(0, 10)
      //console.log(date1)
      return date1
    }
  },
  data() {
    return {
      errAuthList: '',
      authList: [],
      logoutDialog: false
    }
  },
  created() {
    this.getAuthList()
  },
  destroyed() {
    //console.log('destroy')
  },
  methods: {
    getAuthList() {
      var value = JSON.parse(sessionStorage.getItem('MemberInfo'))
      //console.log(value.UserID)
      const url = 'Account/GetAuthList'
      const parameter = {
        Version: 1,
        UserID: value.UserID
      }
      //console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          //console.log(response.data)
          if (response.data.length == 0) {
            this.errAuthList = ''
          } else {
            if (response.data[0].trnauthid) {
              this.errAuthList = ''
              this.authList = response.data
            } else {
              this.errAuthList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.errAuthList = error
        })
    },
    authListInfo(authid, hdrid, authType) {
      sessionStorage.setItem(
        'authListInfo',
        JSON.stringify({
          authid: authid,
          hdrid: hdrid,
          authType: authType
        })
      )

      this.$router.replace('/authInfo')
    },
    sureLogOut() {
      this.logoutDialog = false
      this.$router.replace('/')
    },
    backToLogin() {
      this.logoutDialog = true
    }
  }
}
</script>

<style>
.border {
  padding: 10px;
  border: 1px solid gainsboro;
  border-radius: 15px;
}
.listTxt {
  font-size: 14px;
}
</style>
